export const environment = {
  production: true,
  keycloak: {
    url: "https://keycloak.vavatech.pl/auth/",
    realm: "homas",
    clientId: "homas-frontend"
  },
  busy: {
    book: {
      template: `<div class="loading-page d-flex align-items-center justify-content-center">
      <div>
        <h5>Ładuję dane</h5>
        <div class="cssload-container">
          <div class="cssload-loading"><i></i><i></i><i></i><i></i></div>
        </div>
      </div>
    </div>`,
      minDuration: 1000,
      busy: null
    }
  }

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts